import React from "react";
import { ProfileCarouselProps } from "../dashboard.types";
import ProfilePreviewCard from "./ProfilePreviewCard";

const ProfileCarousel: React.FC<ProfileCarouselProps> = ({
  profiles,
  emptyLabel,
  scoreLabel,
  callLabel,
  viewLabel,
  shareLabel,
  showActions = true,
  layout = "scroll",
  badgeLabel,
  badgeClassName,
  onView,
  onShare,
  onCall,
  renderExtraActions,
}) => {
  if (profiles.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500">
        {emptyLabel}
      </div>
    );
  }

  const renderProfile = (profile: (typeof profiles)[number]) => {
    const profileKey = String(
      profile.recordId || profile.id || profile.name,
    );

    return (
      <ProfilePreviewCard
        key={profileKey}
        profile={profile}
        scoreLabel={scoreLabel}
        callLabel={callLabel}
        viewLabel={viewLabel}
        shareLabel={shareLabel}
        showActions={showActions}
        layout={layout}
        badgeLabel={badgeLabel}
        badgeClassName={badgeClassName}
        onView={onView}
        onShare={onShare}
        onCall={onCall}
        extraActions={renderExtraActions?.(profile)}
      />
    );
  };

  if (layout === "grid") {
    return (
      <div className="grid w-full grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
        {profiles.map(renderProfile)}
      </div>
    );
  }

  return (
    <div className="-mx-4 overflow-x-auto px-4 pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
      <div
        className={`grid w-max auto-cols-[145px] grid-flow-col gap-3 sm:auto-cols-[170px] ${
          profiles.length > 2 ? "grid-rows-2" : "grid-rows-1"
        }`}
      >
        {profiles.map(renderProfile)}
      </div>
    </div>
  );
};

export default ProfileCarousel;